import { render, staticRenderFns } from "./Masthead.vue?vue&type=template&id=70bd713f&scoped=true&"
import script from "./Masthead.vue?vue&type=script&lang=js&"
export * from "./Masthead.vue?vue&type=script&lang=js&"
import style0 from "./Masthead.vue?vue&type=style&index=0&id=70bd713f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd713f",
  null
  
)

export default component.exports